import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'myCapitalize' })
export class CapitalizePipe implements PipeTransform {
  public transform(value: any) {
    if (value) {
      return value.charAt(0).toLocaleUpperCase() + value.slice(1);
    }
    return value;
  }
}
